const getData = require("../../components/getData/getData");
const gamedefault = require("./gamedefault");
function floatAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    return m = Math.pow(10, Math.max(r1, r2)), parseFloat(((arg1 * m + arg2 * m) / m).toFixed(5));
}

function floatSubtr(arg1, arg2) {
    return floatAdd(arg1, -arg2);
}
const getQuickNumberList = () => {
    var gameNumber = window.sessionStorage.getItem("gameNumber");
    if (!gameNumber) return [];
    try {
        var list = JSON.parse(gameNumber);
        return Array.isArray(list) ? list : [];
    } catch (e) {
        return [];
    }
}
const isQuickNumberMatch = (value, rule) => {
    value = (value || "").toString();
    rule = (rule || "").toString();
    if (value.length != rule.length) return false;
    if (value.replace(/[0-9]/g, "口") == rule) return true;
    for (var i = 0; i < rule.length; i++) {
        if (rule[i] == "口") {
            if (!/[0-9]/.test(value[i])) return false;
        } else if (value[i] != rule[i]) {
            return false;
        }
    }
    return true;
}
const isQuickNumberPrefix = (value, rule) => {
    value = (value || "").toString();
    rule = (rule || "").toString();
    if (value.length > rule.length) return false;
    if (value.replace(/[0-9]/g, "口") == rule.substr(0, value.length)) return true;
    for (var i = 0; i < value.length; i++) {
        if (rule[i] == "口") {
            if (!/[0-9]/.test(value[i])) return false;
        } else if (value[i] != rule[i]) {
            return false;
        }
    }
    return true;
}
const hasQuickNumberMatch = (value) => {
    return getQuickNumberList().some(function (rule) {
        return isQuickNumberMatch(value, rule);
    });
}
const hasQuickNumberPrefix = (value) => {
    return getQuickNumberList().some(function (rule) {
        return isQuickNumberPrefix(value, rule);
    });
}
const getQuickNumberMaxLength = () => {
    var list = getQuickNumberList();
    var maxLength = 0;
    list.forEach(function (rule) {
        rule = (rule || "").toString();
        if (rule.length > maxLength) maxLength = rule.length;
    });
    return maxLength;
}
const getDWTypeByName = (name) => {
    name = name.toUpperCase();
    if (name.length == 4) name = name + "X";
    //一字定
    if (name.match("\\dXXXX")) {
        return parseInt(name[0]) + 1;
    } else if (name.match("X\\dXXX")) {
        return parseInt(name[1]) + 15;
    } else if (name.match("XX\\dXX")) {
        return parseInt(name[2]) + 29;
    } else if (name.match("XXX\\dX")) {
        return parseInt(name[3]) + 43;
    } else if (name.match("XXXX\\d")) {
        return parseInt(name[4]) + 57;
    }
    //二字定
    else if (name.match("\\d{2}XXX")) {
        return 108 + parseInt(name[0]) * 10 + parseInt(name[1]);
    } else if (name.match("\\dX\\dXX")) {
        return 208 + parseInt(name[0]) * 10 + parseInt(name[2]);
    } else if (name.match("\\dXX\\dX")) {
        return 308 + parseInt(name[0]) * 10 + parseInt(name[3]);
    } else if (name.match("\\dXXX\\d")) {
        return 408 + parseInt(name[0]) * 10 + parseInt(name[4]);
    } else if (name.match("X\\d{2}XX")) {
        return 508 + parseInt(name[1]) * 10 + parseInt(name[2]);
    } else if (name.match("X\\dX\\dX")) {
        return 608 + parseInt(name[1]) * 10 + parseInt(name[3]);
    } else if (name.match("X\\dXX\\d")) {
        return 708 + parseInt(name[1]) * 10 + parseInt(name[4]);
    } else if (name.match("XX\\d{2}X")) {
        return 808 + parseInt(name[2]) * 10 + parseInt(name[3]);
    } else if (name.match("XX\\dX\\d")) {
        return 908 + parseInt(name[2]) * 10 + parseInt(name[4]);
    } else if (name.match("XXX\\d\\d")) {
        return 1008 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    //三字定
    else if (name.match("\\d{3}XX")) {
        return 1108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[2]);
    } else if (name.match("\\d{2}X\\dX")) {
        return 2108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[3]);
    } else if (name.match("\\d{2}XX\\d")) {
        return 3108 + parseInt(name[0]) * 100 + parseInt(name[1]) * 10 + parseInt(name[4]);
    } else if (name.match("\\dX\\d{2}X")) {
        return 4108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    } else if (name.match("\\dX\\dX\\d")) {
        return 5108 + parseInt(name[0]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    } else if (name.match("\\dXX\\d{2}")) {
        return 6108 + parseInt(name[0]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    } else if (name.match("X\\d{3}X")) {
        return 7108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    } else if (name.match("X\\d{2}X\\d")) {
        return 8108 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    } else if (name.match("X\\dX\\d{2}")) {
        return 9108 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    } else if (name.match("XX\\d{3}")) {
        return 10108 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }

    else if (name.match("\\d{4}X")) {
        return 11108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[3]);
    } else if (name.match("\\d{3}X\\d")) {
        return 21108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[2]) * 10 + parseInt(name[4]);
    } else if (name.match("\\d{2}X\\d{2}")) {
        return 31108 + parseInt(name[0]) * 1000 + parseInt(name[1]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    } else if (name.match("\\dX\\d{3}")) {
        return 41108 + parseInt(name[0]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    } else if (name.match("X\\d{4}")) {
        return 51108 + parseInt(name[1]) * 1000 + parseInt(name[2]) * 100 + parseInt(name[3]) * 10 + parseInt(name[4]);
    }


    return 0;

}
var S = {
    request: null,
    intervalTime: null,
    intervalOpenTime: null,
    initialization: null,
    scrollinterval: null,
    stop: true,
    lineStop: true,
    loadingWrap: true,
    backList: [],
    action: "/totaldata/action.ashx",
    loginDefautl: "/login/?e=" + +new Date()
};
function game_loading_wrap(stop) {
    if (S.loadingWrap) {
        if (stop) {
            $(".game_loading_wrap").css("display", "block");
            $("#gameBox").css("display", "none");
        } else {
            $(".game_loading_wrap").css("display", "none");
            $("#gameBox").css("display", "block");
        }
    }
}

function fastbet(msg) {
    $("#mainIframe").find("div[class='gameLeft']").attr("style", "");
    $("#mainIframe").find("div[class='game_wrap']").attr("style", "");
    $("#mainIframe").find("div[class='game_item_warp']").attr("style", "");
    $("#gameBoxTool").attr("style", "");


    var gameIndex = msg.gameIndex;
    var betList = msg.data.betList;
    var len = betList.length;
    var htmlData = ["<div class='t_1'> <div class='history_wrap'>"];
    htmlData.push("<table >");
    htmlData.push("<thead><th width='10%'>彩种</th><th width='20%'>注单编号</th><th width='10%'>号码</th><th width='9%'>赔率</th><th width='9%'>金额</th><th width='9%'>回水</th><th width='9%'>状态</th ><th width='10%'>全选<input id='quanxian' type='checkbox'><input id='tuima' type='button' value='退码'></th></thead>");
    htmlData.push("<tbody id='betList'>");
    htmlData.push(betListHtml(betList));
    htmlData.push("</tbody>");
    htmlData.push("</table>");
    htmlData.push("</div></div>");
    game_loading_wrap(false);
    $("#gameBox").html(htmlData.join(""));

    var gameBoxTool = "<div class=\"tool_left\"><div id=\"tool_ys_wrap\" class=\"t_left\">" +
        "<label for=\"tool_hm_input\">号码：</label><input id=\"tool_hm_input\" placeholder='x=X' class=\"input\" maxlength='5' type=\"text\">" +
        "&nbsp;&nbsp;&nbsp;&nbsp;<label for=\"tool_ys_input\">下注金额：</label><input id=\"tool_ys_input\" class=\"input onlyNum\" maxlength='5' type=\"text\">" +
        "&nbsp;&nbsp;<input id=\"fastSubmit\" class=\"btn hotBtn disSubmit\" type=\"button\" value=\"提交\">" +
        "&nbsp;&nbsp;<label id='oddsmoney'></label>" +
        "</div></div>";
    $("#gameBoxTool").html(gameBoxTool);

    //快捷下注金额
    // $("#tool_ys_input").focus(function () {
    //     $(this).val("");
    // });
    $("#tool_ys_input").keyup(function () {
        // $(this).val($(this).val().replace(/[^0-9]/g, ''));
        gamedefault.G.clearNoNum($(this));
    });

    $("#tool_hm_input").keyup(function () {
        $(this).val($(this).val().replace(/[xｘＸ]/g, 'X'));
        var num = $(this).val();
        if (num == "") {
            $("#oddsmoney").html("");
            return;
        }

        if (hasQuickNumberMatch(num)) {
            $("#tool_ys_input").focus();
            let data = {};
            data.access_token = window.sessionStorage.getItem("login").split("&")[0];
            data.uid = window.sessionStorage.getItem("login").split("&")[1];
            data.game_code = window.sessionStorage.getItem("code");
            data.bet_str = num;
            getData.default.postAxiosMethod("kuaidaodds", data, res => {
                $("#oddsmoney").html(`<span>&nbsp;赔率：</span><span id="spanPeilv" style='color: #0b8fff;font-weight: bold'>${res.data.data.odds}</span>&nbsp;&nbsp;&nbsp;&nbsp;<span>可下：</span><span id="spankxje" style='color: red;font-weight: bold'>${res.data.data.maxCount}</span>`);
            });
        } else {
            $("#oddsmoney").html("");
            var maxLength = getQuickNumberMaxLength();
            if (maxLength > 0 && num.length >= maxLength && !hasQuickNumberPrefix(num)) {
                gamedefault.G.myTips({ content: "输入号码有误", obj: $(this) });
                $(this).val("");
            }
        }
    });

    $("#quanxian").unbind("change").change(function () {

        var checked = $(this).attr("checked") ? true : false;

        $("#betList").find("input[type='checkbox']").attr("checked", checked);

    });

    $("#tuima").unbind("click").click(function () {
        var idAry = [];
        $("#betList").find("input[type='checkbox']:checked").each(function () {
            idAry.push($(this).attr("data-id"));
        });
        if (idAry.length == 0) {
            gamedefault.G.alert({ content: "至少勾选1个需要“退码”的订单！", ok: function () { return true; } });
        } else {
            gamedefault.G.mask();
            gamedefault.G.ajax("tuima&data=" + idAry.join(",") + "&gameIndex=" + gameIndex, function (json) {
                gamedefault.G.maskClose();
                if (json.result == 1) {
                    $("#betList").html(betListHtml(json.betList));
                    lastBetData(json);
                } else {
                    gamedefault.G.alert({ content: json.result, ok: function () { return true; } });
                }
            }, function () { gamedefault.G.maskClose(); });
        }
    });

    $('#tool_ys_input').unbind("keyup").keyup(function(event){
        if($('#fastSubmit').length > 0){
            $('#fastSubmit').click()
        }
    });

    $("#fastSubmit").unbind("click").click(function () {
        var data_number = $("#NowJq").html();
        var money = $("#tool_ys_input").val();
        if (money == "" || money <= 0) {
            return;
        }

        var num = $("#tool_hm_input").val();
        var type = getDWTypeByName(num);
        if (type == 0) return;
        gamedefault.G.mask();
        gamedefault.G.ajax("DownEntry&gameIndex=3&sortAry=" + type + ":" + money + "&number=" + data_number + "&fast=true&betType=3", function (json) {

            if (json.result != 1) {
                gamedefault.G.maskClose();
                gamedefault.G.alert({ content: json.result, ok: function () { return true; } });
                return;
            } else {
                $("#tool_hm_input").val("");

                $("#betList").html(betListHtml(json.betList));
                lastBetData(json);
            }

            gamedefault.G.maskClose();
        }, function () { gamedefault.G.maskClose(); });

    });
}

function betListHtml(betList) {
    var html = [];
    var len = betList.length;
    for (var i = 0; i < 10; i++) {
        html.push("<tr>");

        if (i < len) {
            var state = betList[len - 1 - i][6] == 1 ? "成功" : "退码";
            var check = betList[len - 1 - i][7] == 1 ? "<input data-id='" + betList[len - 1 - i][8] + "' type='checkbox'>" : "--";

            var bg = betList[len - 1 - i][6] == 1 ? "" : "style='background: #FFC184'";
            bg = bg == "" ? (betList[len - 1 - i][9] == 1 ? "style='background: #FFFFB9'" : "") : bg;

            html.push("<td " + bg + " >" + betList[len - 1 - i][0] + "</td>");
            html.push("<td " + bg + ">" + betList[len - 1 - i][1] + "</td>");
            html.push("<td " + bg + ">" + betList[len - 1 - i][2] + "</td>");
            html.push("<td " + bg + ">" + betList[len - 1 - i][3] + "</td>");
            html.push("<td " + bg + ">" + betList[len - 1 - i][4] + "</td>");
            html.push("<td " + bg + ">" + betList[len - 1 - i][5] + "</td>");
            html.push("<td " + bg + ">" + state + "</td>");
            html.push("<td " + bg + ">" + check + "</td>");
        } else {
            html.push("<td >--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
            html.push("<td>--</td>");
        }

        html.push("</tr>");
    }

    return html.join("");
}

//快选
function kuaixian(category) {

    $("#mainIframe").find("div[class='gameLeft']").attr("style", "width: 600px");
    $("#mainIframe").find("div[class='game_wrap']").attr("style", "width: 600px");
    $("#mainIframe").find("div[class='game_item_warp']").attr("style", "width: 600px");
    $("#gameBoxTool").attr("style", "width: 578px;min-width: 578px");

    game_loading_wrap(false);
    kxcontent(category);
    var htmlData = ["<div  class='t_1' style='max-height: 500px;min-height: 370px'> <span id='kxlog' style='display: none'></span> <div id='kxnumbers' class='history_wrap' style='max-height: 500px;min-height: 370px'>"];

    htmlData.push("</div></div>");
    $("#gameBox").html(htmlData.join(""));

    var gameBoxTool = "<div class='tool_left'>" +
        "<div id='tool_ys_wrap' class='t_left'>" +
        "<label for='tool_ys_input'>下注金额：</label><input id='tool_ys_input' class='input onlyNum' maxlength='5' type='text'>" +
        "&nbsp;&nbsp;<input id='kxSubmit' class='btn hotBtn disSubmit' type='button' value='提交'>" +
        " &nbsp;&nbsp;笔数：<span id='zbishu' style='color: #ff0000'></span>" +
        " &nbsp;&nbsp;金额：<span id='zmoney' style='color: #ff0000'></span>" +
        "</div></div>";
    $("#gameBoxTool").html(gameBoxTool);

    $("#tool_ys_input").keyup(function () {
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        gamedefault.G.clearNoNum($(this));
        var bishu = $("#zbishu").html();
        if (bishu.length > 0 && $(this).val().length > 0) {
            $("#zmoney").html(parseInt(bishu) * parseFloat($(this).val()));
        } else {
            $("#zmoney").html("");
        }

    });



    $('#tool_ys_input').bind('keypress', function (event) {//监听sim卡回车事件
        if (event.keyCode == "13") {
            var money = $("#tool_ys_input").val();
            if (money.length == 0 || parseFloat(money) <= 0) {
                return;
            }

            var numberArr = [];
            $("#kxnumbers").find("td").each(function () {
                var number = $(this).html();z
                var type = getDWTypeByName(number);
                if (type > 0) numberArr.push(type + ":" + money);
            });

            if (numberArr.length == 0) {
                return;
            }

            if (numberArr.length > 10000) {
                gamedefault.G.alert({ content: "单笔最大只能下注10000注", ok: function () { return true; } });
                return;
            }

            var gameIndex = $("#menuText").attr("data-index");
            var opNum = $("#NowJq").html();
            numberArr.sort(function (a, b) {
                var _a = a.split(":")[0], _b = b.split(":")[0];
                return parseInt(_b) - parseInt(_a);
            });
            var printAry = [];

            if ($("#tool_ys_input").val().length == 0) return;

            $("#tool_ys_input").val("");

            dataSubmit({ gameIndex: gameIndex, betType: 4, data: $("#kxlog").html(), number: opNum, sortAry: numberArr.join(",") }, false, null, printAry);

        }
    });

}

function kxcontent(dataAction) {

    var active = [dataAction == 2 ? "active" : "", dataAction == 3 ? "active" : "", dataAction == 4 ? "active" : ""];
    var rightBox =
        "<div  class='game_box_title t_1' style='width: 600px;background: white'>" +
        "<ul class='base-clear' id='kuaixianList'>" +
        "<li class='subBtn " + active[0] + "'><a href='javascript:void(0)' data-action='2'>二字定</a></li>" +
        "<li class='subBtn " + active[1] + "'><a href='javascript:void(0)' data-action='3'>三字定</a></li>" +
        "<li class='subBtn " + active[2] + "'><a href='javascript:void(0)' data-action='4'>四字定</a></li>" +
        "</ul>" +
        "<div id='kx_content' class='history_wrap'>" +
        "</div>" +
        "</div>";
    $("#rightBox").html(rightBox);



    var wz = dataAction == 2 ? "二" : dataAction == 3 ? "三" : "四";

    var htmlData = ["<table>"];

    htmlData.push("<tbody>");

    htmlData.push("<tr class='position-filter' >" +
        " <td  colspan='2' > " +
        "<strong class='red2'>定位置</strong> <label><input type='checkbox' positiontype='0' positionfilter='1' >除</label> <label><input type='checkbox' positiontype='0' positionfilter='0'  checked='checked'>取</label> </td> " +
        "<td  colspan='3' >" +
        " <strong class='red2'>配数全转</strong> <label><input positiontype='1' positionfilter='1' type='checkbox' >除</label> <label><input positiontype='1' positionfilter='0' type='checkbox' >取</label> </td> </tr>");

    htmlData.push("<tr><td colspan='5'>");
    if (dataAction == 2) htmlData.push(" <input name='dw5zi' type='checkbox'> 五位二定 ");
    else if (dataAction == 3) htmlData.push(" <input name='dw5zi' type='checkbox'> 五位三定 ");
    else {
        htmlData.push(" <input name='dw5zi' data-index='5' type='checkbox' checked> 一五四定 ");
        htmlData.push(" <input name='dw5zi' data-index='4' type='checkbox'> 二五四定 ");
        htmlData.push(" <input name='dw5zi' data-index='3' type='checkbox'> 三五四定 ");
        htmlData.push(" <input name='dw5zi' data-index='2' type='checkbox'> 四五四定 ");
        htmlData.push(" <input name='dw5zi' data-index='1' type='checkbox'> 五五四定 ");

    }
    htmlData.push("</tr></td>");
    //定位
    htmlData.push("<tr class='fixed-input'>");
    htmlData.push("<td width='20%'>千</td>");
    htmlData.push("<td width='20%'>百</td>");
    htmlData.push("<td width='20%'>十</td>");
    htmlData.push("<td width='20%'>个</td>");
    htmlData.push("<td width='20%'>尾</td>");
    htmlData.push("</tr>");
    htmlData.push("<tr class='fixed-input'>");
    htmlData.push("<td><input name='wan' autocomplete='off' class='input input2'  type='text'></td>");
    htmlData.push("<td><input name='qian' autocomplete='off' class='input input2' type='text'></td>");
    htmlData.push("<td><input name='bai' autocomplete='off' class='input input2'  type='text'></td>");
    htmlData.push("<td><input name='shi' autocomplete='off' class='input input2'  type='text'></td>");
    htmlData.push("<td><input name='ge' autocomplete='off' class='input input2'  type='text'></td>");
    htmlData.push("</tr>");


    //配
    htmlData.push("<tr class='match-input' style='display: none'>");
    htmlData.push("<td colspan='5'>");
    htmlData.push(" <input name='pei1' autocomplete='off' class='input input2'  type='text'> 配 <input name='pei2' autocomplete='off' class='input input2'  type='text'>");

    if (dataAction >= 3) htmlData.push(" 配 <input name='pei3' autocomplete='off' class='input input2'  type='text'>");
    if (dataAction == 4) htmlData.push(" 配 <input name='pei4' autocomplete='off' class='input input2'  type='text'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    htmlData.push("<tr class='hefen-filter'> <td colspan='5'> <strong class='red2'>合</strong>&nbsp;&nbsp; <strong class='red2'>分</strong> <label><input type='checkbox' hefentype='1'>除</label> <label><input type='checkbox' hefentype='0'  checked='checked'>取</label> </td> </tr>");
    htmlData.push("<tr>");
    htmlData.push("<td class='hefen-filter-item'> 1. <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <br> <input type='text' class='input input2'  maxlength='10'> </td>");
    htmlData.push("<td class='hefen-filter-item'> 2. <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <br> <input type='text' class='input input2'  maxlength='10'> </td>");
    htmlData.push("<td class='hefen-filter-item'> 3. <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <br> <input type='text' class='input input2'  maxlength='10'> </td>");
    htmlData.push("<td class='hefen-filter-item'> 4. <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <br> <input type='text' class='input input2'  maxlength='10'> </td>");
    htmlData.push("<td class='hefen-filter-item'> 5. <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <input type='checkbox'> <br> <input type='text' class='input input2'  maxlength='10'> </td>");
    htmlData.push("</tr>");



    var colspan = 5;
    if (dataAction == 4) colspan = 2;
    //不定位合分
    htmlData.push("<tr>");
    htmlData.push("<td class='budinghe-filter' style='text-align: left' colspan='" + colspan + "' ><strong class='red2'>不定位合分</strong> <label><input type='checkbox' budinghetype='2' >两数合</label> ");
    if (dataAction == 3 || dataAction == 4) {
        htmlData.push("<label><input type='checkbox' budinghetype='3'  >三数合</label>");
    }
    htmlData.push("&nbsp;&nbsp; <input type='text' class='input input2' maxlength='10'>");
    if (dataAction == 4) {
        htmlData.push("<td class='zhi-filter-range' colspan='3'>");
        htmlData.push("<strong class='red2'>值 范 围</strong> 从 ");
        htmlData.push("<input type='text' class='input input2' name='zhifanwei1'  maxlength='10'> 值 至 ");
        htmlData.push("<input type='text' class='input input2' name='zhifanwei2'  maxlength='10'>");

        htmlData.push("</td>");
    }

    htmlData.push("</tr>");

    //全转 上奖 排除 乘号位置
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' style='text-align: left'>");
    htmlData.push("<strong class='red2'>全转</strong> <input type='text' class='input input2' name='quanzhuan' maxlength=\"10\">");
    htmlData.push("&nbsp;<strong class='red2'>上奖</strong> <input type='text' class='input input2' name='shangjiang' maxlength=\"10\">");
    htmlData.push("&nbsp;<strong class='red2'>排除</strong> <input type='text' class='input input2' name='paichu' maxlength=\"10\">");
    if (dataAction != 4) htmlData.push("&nbsp;<strong class='red2'>乘号位置</strong><input type='checkbox' class='symbol-filter-item' name='0'>&nbsp;<input type='checkbox' class='symbol-filter-item' name='1'>&nbsp;<input type='checkbox' class='symbol-filter-item' name='2'>&nbsp;<input type='checkbox' class='symbol-filter-item' name='3'>&nbsp;<input type='checkbox' class='symbol-filter-item' name='4'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");


    //含 复式
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' class='contain-filter' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' containfilter='1' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' containfilter='0' >&nbsp;取</label>");
    htmlData.push(" " + wz + "字定含 <input type='text' class='input input2' name='han' maxlength='10'>");
    htmlData.push(" " + wz + "字定复式 <input type='text' class='input input2' name='fushi' maxlength='10'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    //双重
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' class='repeat-two-words-filter' repeatwordsfilter='1' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-two-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>双重</strong>)");

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-double-words-filter' repeatwordsfilter='1' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-double-words-filter' repeatwordsfilter='0' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>双双重</strong>)");
    }

    if (dataAction >= 3) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-three-words-filter' repeatwordsfilter='1'>&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-three-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>三重</strong>)");
    }

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input type='checkbox' class='repeat-four-words-filter' repeatwordsfilter='1'>&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input type='checkbox' class='repeat-four-words-filter' repeatwordsfilter='0'>&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>四重</strong>)");
    }

    htmlData.push("</td>");
    htmlData.push("</tr>");

    //兄弟
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' style='text-align: left'>");
    htmlData.push("<label><input class='two-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input class='two-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>二兄弟</strong>)");

    if (dataAction >= 3) {
        htmlData.push("&nbsp;&nbsp;<label><input class='three-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input class='three-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>三兄弟</strong>)");
    }

    if (dataAction == 4) {
        htmlData.push("&nbsp;&nbsp;<label><input class='four-brother-filter' brotherfilter='1' type='checkbox' >&nbsp;除</label>");
        htmlData.push("&nbsp;<label><input class='four-brother-filter' brotherfilter='0' type='checkbox' >&nbsp;取</label>");
        htmlData.push("(<strong class='red2'>四兄弟</strong>)");
    }

    htmlData.push("</td>");
    htmlData.push("</tr>");

    //对数
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' style='text-align: left'>");
    htmlData.push("<label><input class='logarithm-number-filter' logarithmnumberfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input class='logarithm-number-filter' logarithmnumberfilter='0' type='checkbox' >&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>对数</strong>)");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu1'  maxlength='2'>");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu2'  maxlength='2'>");
    htmlData.push("&nbsp;<input type='text' class='input input2' name='duishu3'  maxlength='2'>");
    htmlData.push("</td>");
    htmlData.push("</tr>");

    //单双
    htmlData.push("<tr>");
    htmlData.push("<td colspan='5' style='text-align: left'>");
    htmlData.push("<label><input type='checkbox' class='odd-number-filter' oddnumberfilter='1'>&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='odd-number-filter' oddnumberfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>单</strong>)");
    htmlData.push("&nbsp;<input type='checkbox' class='odd-number-item'>&nbsp;<input type='checkbox' class='odd-number-item'>&nbsp;<input type='checkbox' class='odd-number-item'>&nbsp;<input type='checkbox' class='odd-number-item'>&nbsp;<input type='checkbox' class='odd-number-item'>");

    htmlData.push(" &nbsp;&nbsp;&nbsp;&nbsp;<label><input class='even-number-filter' evennumberfilter='1' type='checkbox' >&nbsp;除</label>");
    htmlData.push("&nbsp;<label><input type='checkbox' class='even-number-filter' evennumberfilter='0'>&nbsp;取</label>");
    htmlData.push("(<strong class='red2'>双</strong>)");
    htmlData.push("&nbsp;<input type='checkbox' class='even-number-item'>&nbsp;<input type='checkbox' class='even-number-item'>&nbsp;<input type='checkbox' class='even-number-item'>&nbsp;<input type='checkbox' class='even-number-item'>&nbsp;<input type='checkbox' class='even-number-item'>");

    htmlData.push("</td>");
    htmlData.push("</tr>");

    htmlData.push("<tr><td colspan='5'>");
    htmlData.push("<input name='create-number' class='btn hotBtn disSubmit' type='button' value='生成'>")
    htmlData.push("&nbsp;&nbsp;<input name='reset-number' class='btn grayBtn' type='button' value='重置'>");
    // htmlData.push("&nbsp;&nbsp;<span id='kxlog' category='"+dataAction+"' style='color: #004eff'>投注日志</span>");
    htmlData.push("</td></tr>");

    htmlData.push("</tbody>");

    htmlData.push("</table>");



    $("#kx_content").html(htmlData.join(""));


    kuaiXuanClick();

}

function kuaiXuanClick() {

    $("#kx_content input[type='text']").keyup(function () {
        $(this).val($(this).val().replace(/[^0-9]/g, ''));
    });

    $("#kx_content tr.position-filter input").unbind("change").change(function () {
        var positiontype = $(this).attr("positiontype");
        var positionfilter = $(this).attr("positionfilter");
        $("#kx_content tr.position-filter input").attr("checked", false);
        $(this).attr("checked", "checked");

        if (positiontype == 0) {
            $("#kx_content tr.fixed-input").attr("style", "");
            $("#kx_content tr.match-input").attr("style", "display: none");
            $("#kx_content tr.match-input input[type='text']").val('');
        } else {
            $("#kx_content tr.fixed-input").attr("style", "display: none");
            $("#kx_content tr.match-input").attr("style", "");
            $("#kx_content tr.fixed-input input[type='text']").val('');

        }
    });


    $("#kx_content tr.hefen-filter input").unbind("change").change(function () {
        $("#kx_content tr.hefen-filter input").attr("checked", false);
        $(this).attr("checked", "checked");
    });

    $("#kx_content td.budinghe-filter input[type='checkbox']").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content td.budinghe-filter input[type='checkbox']").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    //contain-filter
    $("#kx_content td.contain-filter input[type='checkbox']").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content td.contain-filter input[type='checkbox']").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content  input.repeat-two-words-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.repeat-two-words-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.repeat-three-words-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.repeat-three-words-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.repeat-four-words-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.repeat-four-words-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.repeat-double-words-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.repeat-double-words-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });


    $("#kx_content input.two-brother-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.two-brother-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.three-brother-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.three-brother-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.four-brother-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.four-brother-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.logarithm-number-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.logarithm-number-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.odd-number-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.odd-number-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input.even-number-filter").unbind("change").change(function () {

        if ($(this).attr("checked") == "checked") {
            $("#kx_content input.even-number-filter").attr("checked", false);
            $(this).attr("checked", "checked");
        }
    });


    $("#kuaixianList a[data-action]").unbind("click").click(function () {

        var dataAction = $(this).attr("data-action");

        $("#kuaixianList li").removeClass("active");
        $(this).parent("li").addClass("active");

        kxcontent(dataAction);

    });


    $("#kx_content input[name='dw5zi']").unbind("click").click(function () {

        if ($("#kuaixianList li.active a").attr("data-action") == 4) {
            var checks = document.getElementsByName("dw5zi");

            for (var i = 0; i < checks.length; i++) {
                checks[i].checked = false;
            }
            $(this).attr("checked", "checked");
        }
    });

    $("#kx_content input[name='create-number']").unbind("click").click(function () {
        var positiontype = $("#kx_content tr.position-filter input:checked").attr("positiontype");
        var positionfilter = $("#kx_content tr.position-filter input:checked").attr("positionfilter");
        var category = $("#kuaixianList li.active a").attr("data-action");

        //五位
        var dw5zi = 0;
        if (category == 4) {
            var obj = $("#kx_content input[name='dw5zi']:checked");
            if (obj) dw5zi = obj.attr("data-index");

        } else dw5zi = $("#kx_content input[name='dw5zi']").attr("checked") == "checked" ? 1 : 0;

        //日志
        var kxlog = [];
        //生成号码数字
        var createNumberArr = [];
        //是否有输入条件
        var inputCondition = false;
        //全部号码
        var allNumberArr = [];
        //定位置
        if (positiontype == 0) {

            var wan = $("#kx_content tr.fixed-input input[name='wan']").val();
            var qian = $("#kx_content tr.fixed-input input[name='qian']").val();
            var bai = $("#kx_content tr.fixed-input input[name='bai']").val();
            var shi = $("#kx_content tr.fixed-input input[name='shi']").val();
            var ge = $("#kx_content tr.fixed-input input[name='ge']").val();

            var posNumArr = [wan, qian, bai, shi, ge];
            //填写号码的位置
            var numPos = [];
            wan.length > 0 ? numPos.push(0) : "";
            qian.length > 0 ? numPos.push(1) : "";
            bai.length > 0 ? numPos.push(2) : "";
            shi.length > 0 ? numPos.push(3) : "";
            ge.length > 0 ? numPos.push(4) : "";

            if (numPos.length > 0) {
                inputCondition = true;
                kxlog.push("1|" + positionfilter + "|" + posNumArr.join(":"));
            }


            if (category == numPos.length) {
                createNumberArr = dwcreatenumber(category, posNumArr, numPos);

                //除
                if (positionfilter == 1) {
                    var tmpPosNumArr = ["", "", "", "", ""];
                    for (var n = 0; n < numPos.length; n++) {
                        tmpPosNumArr[numPos[n]] = "0123456789";
                    }
                    allNumberArr = dwcreatenumber(category, tmpPosNumArr, numPos);
                }
            } else if (numPos.length > 0 && numPos.length < category) {
                var numPosArr;
                if (category == 2) {
                    if (dw5zi == 0) numPosArr = [[0, 1], [0, 2], [0, 3], [1, 2], [1, 3], [2, 3]];
                    else numPosArr = [[0, 4], [1, 4], [2, 4], [3, 4]];
                } else if (category == 3) {
                    if (dw5zi == 0) numPosArr = [[0, 1, 2], [0, 1, 3], [0, 2, 3], [1, 2, 3]];
                    else numPosArr = [[0, 1, 4], [0, 2, 4], [0, 3, 4], [1, 2, 4], [1, 3, 4], [2, 3, 4]];
                } else if (category == 4) {

                    numPosArr = [[0, 1, 2, 3], [0, 1, 2, 4], [0, 1, 3, 4], [0, 2, 3, 4], [1, 2, 3, 4]];
                    var index = [4, 3, 2, 1, 0];
                    numPosArr = [numPosArr[index[dw5zi - 1]]];
                }

                for (var i = 0; i < numPosArr.length; i++) {
                    tmpPosNumArr = posNumArr;
                    var posArr = numPosArr[i];

                    var c = false;
                    for (var n = 0; n < numPos.length; n++) {
                        if (posArr.indexOf(numPos[n]) == -1) {
                            c = true;
                            break;
                        }
                    }
                    if (c) continue;

                    var tmpPosNumArr2 = ["", "", "", "", ""];
                    for (var n = 0; n < posArr.length; n++) {
                        if (tmpPosNumArr[posArr[n]].length == 0) tmpPosNumArr[posArr[n]] = "0123456789";

                        if (positionfilter == 1) {
                            tmpPosNumArr2[posArr[n]] = "0123456789";
                        }
                    }

                    createNumberArr = createNumberArr.concat(dwcreatenumber(category, tmpPosNumArr, posArr));
                    if (positionfilter == 1) allNumberArr = allNumberArr.concat(dwcreatenumber(category, tmpPosNumArr2, posArr));
                }
            }

        } else { //配数
            var peiNumArr = [];
            var peiNumArr2 = [];
            for (var i = 1; i <= category; i++) {
                var psn = $("#kx_content tr.match-input input[name='pei" + i + "']").val();
                if (psn.length > 0) {
                    inputCondition = true;
                    peiNumArr2.push(psn);
                }
                peiNumArr.push(psn.length == 0 ? "0123456789" : psn);
            }

            if (inputCondition) {
                if (positionfilter == 1) allNumberArr = getNumbersByCategory(category, dw5zi);
                createNumberArr = peishuquanzhuan(category, peiNumArr, dw5zi, false);

                kxlog.push("2|" + positionfilter + "|" + peiNumArr2.join(":"));

            }
        }

        if (positionfilter == 1) {
            var newNumberArr = [];
            for (var n = 0; n < allNumberArr.length; n++) {
                if (createNumberArr.indexOf(allNumberArr[n]) == -1) newNumberArr.push(allNumberArr[n]);
            }
            createNumberArr = newNumberArr;
        }

        //全转
        var quanzhaun = $("#kx_content input[name='quanzhuan']").val();
        if (quanzhaun.length > 0) {
            tmpNumArr = [];
            if (quanzhaun.length >= category) {

                var quanzhaunArr = [];
                for (var i = 0; i < category; i++) {
                    quanzhaunArr.push(quanzhaun);
                }
                tmpNumArr = peishuquanzhuan(category, quanzhaunArr, dw5zi, true);

            }
            if (createNumberArr.length == 0 && inputCondition) {
                createNumberArr = [];
            } else if (createNumberArr.length == 0) createNumberArr = tmpNumArr;
            else {
                var tmpNumArr2 = [];
                for (var i = 0; i < tmpNumArr.length; i++) {
                    if (createNumberArr.indexOf(tmpNumArr[i]) != -1) {
                        tmpNumArr2.push(tmpNumArr[i]);
                    }
                }
                createNumberArr = tmpNumArr2;
            }
            inputCondition = true;
            kxlog.push("3|" + quanzhaun);

        }

        //上将
        var shangjiang = $("#kx_content input[name='shangjiang']").val();
        if (shangjiang.length > 0) {
            allNumberArr = getNumbersByCategory(category, dw5zi);
            var tmpNumArr = [];
            for (var n = 0; n < allNumberArr.length; n++) {
                var number = allNumberArr[n];
                var pos = [];
                for (var n2 = 0; n2 < number.length; n2++) {
                    for (var n3 = 0; n3 < shangjiang.length; n3++) {
                        if (number[n2] == shangjiang[n3] && pos.indexOf(n3) == -1) {
                            pos.push(n3);
                            break;
                        }
                    }

                }
                pos = pos.uniquelize();

                if (pos.length == shangjiang.length || pos.length == category) tmpNumArr.push(number);
            }

            if (!inputCondition && quanzhaun.length == 0) {
                createNumberArr = tmpNumArr;
            } else if (createNumberArr.length > 0) {
                if (tmpNumArr.length == 0) createNumberArr = [];
                else createNumberArr = Array.intersect(createNumberArr, tmpNumArr);
            }

            inputCondition = true;
            kxlog.push("4|" + shangjiang);

        }


        //值范围
        if (category == 4) {
            var zhifanwei1 = $("#kx_content td.zhi-filter-range input[name='zhifanwei1']").val();
            var zhifanwei2 = $("#kx_content td.zhi-filter-range input[name='zhifanwei2']").val();
            if (zhifanwei1.length > 0 && zhifanwei2.length > 0) {
                tmpNumArr = [];


                if (!inputCondition && quanzhaun.length == 0 && shangjiang.length == 0) {
                    allNumberArr = getNumbersByCategory(category, dw5zi);
                    for (var i = 0; i < allNumberArr.length; i++) {
                        var number = allNumberArr[i];
                        number = number.replace(/X/g, '');
                        var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                        if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(allNumberArr[i]);
                    }
                    createNumberArr = tmpNumArr;
                } else if (createNumberArr.length > 0) {
                    for (var i = 0; i < createNumberArr.length; i++) {
                        var number = createNumberArr[i];
                        number = number.replace(/X/g, '');
                        var he = parseInt(number[0]) + parseInt(number[1]) + parseInt(number[2]) + parseInt(number[3]);
                        if (he >= parseInt(zhifanwei1) && he <= parseInt(zhifanwei2)) tmpNumArr.push(createNumberArr[i]);
                    }
                    createNumberArr = tmpNumArr;
                }

                inputCondition = true;
                kxlog.push("5|" + zhifanwei1 + "~" + zhifanwei2);

            }
        }


        //合分
        var hefentype = $("#kx_content tr.hefen-filter input:checked").attr("hefentype");

        var hefenInfo = [];
        $("#kx_content td.hefen-filter-item").each(function () {
            var hf = $(this).find("input[type='text']").val();
            if (hf == "") return true;
            var i = 0;
            var pos = [];
            $(this).find("input[type='checkbox']").each(function () {
                if ($(this).attr("checked")) {
                    pos.push(i);
                }
                i++;
            });

            if (pos.length > 0) {
                hefenInfo.push(pos.join(":") + "-" + hf);
            }
        });
        var tmpNumArr = [];
        if (hefenInfo.length > 0) {

            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            for (var i = 0; i < createNumberArr.length; i++) {
                var count = 0;
                for (var n = 0; n < hefenInfo.length; n++) {

                    var hf = hefenInfo[n].split("-")[1];
                    var hfpos = hefenInfo[n].split("-")[0].split(":");
                    var hf2 = 0;
                    for (var n2 = 0; n2 < hfpos.length; n2++) {
                        if (createNumberArr[i][hfpos[n2]] == "X") {
                            hf2 = -1;
                            break;
                        }
                        hf2 += parseInt(createNumberArr[i][hfpos[n2]]);
                    }
                    if (hf2 < 0) continue;

                    for (var n3 = 0; n3 < hf.length; n3++) {
                        if (hf2 % 10 == hf[n3]) {
                            count++;
                            break;
                        }
                    }
                }
                if (count == hefenInfo.length && hefentype == 0 || count != hefenInfo.length && hefentype == 1) tmpNumArr.push(createNumberArr[i]);

            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("6|" + hefentype + "|" + hefenInfo.join(";"));

        }

        //不定位合分
        var budinghetype = $("#kx_content td.budinghe-filter input[type=checkbox]:checked").attr("budinghetype");
        var budinghe = $("#kx_content td.budinghe-filter input[type='text']").val();

        if ((budinghetype == 2 || budinghetype == 3) && budinghe.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);

            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                number = number.replace("/X/g", "");
                var ext = false;
                for (var n = 0; n < number.length; n++) {
                    for (var n2 = n + 1; n2 < number.length; n2++) {
                        if (budinghetype == 2) {
                            var value = (parseInt(number[n]) + parseInt(number[n2])) % 10;
                            if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }
                        } else {
                            for (var n3 = n2 + 1; n3 < number.length; n3++) {
                                var value = (parseInt(number[n]) + parseInt(number[n2]) + parseInt(number[n3])) % 10;
                                if (budinghe.indexOf(value) != -1) { tmpNumArr.push(createNumberArr[i]); ext = true; break; }

                            }
                        }
                        if (ext) break;

                    }
                    if (ext) break;
                }
            }

            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("7|" + budinghetype + "|" + budinghe);

        }

        //排除
        var paichu = $("#kx_content input[name='paichu']").val();
        if (paichu.length > 0) {

            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];

                var b = false;
                for (var n = 0; n < paichu.length; n++) {
                    if (number.indexOf(paichu[n]) != -1) {
                        b = true;
                        break
                    }
                }
                if (!b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("8|" + paichu);

        }

        //乘号位置
        var chhaoArr = [];
        $("#kx_content input.symbol-filter-item:checked").each(function () {
            chhaoArr.push($(this).attr("name"));
        });
        if (chhaoArr.length > 0 && category != 4) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = true;
                for (var n = 0; n < chhaoArr.length; n++) {
                    if (number[chhaoArr[n]] != "X") {
                        b = false;
                        break
                    }
                }
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("9|" + chhaoArr.join(":"));

        }
        //含数复数
        var containfilter = $("#kx_content td.contain-filter input[type='checkbox']:checked").attr("containfilter");
        var han = $("#kx_content td.contain-filter input[name='han']").val();
        var fushi = $("#kx_content td.contain-filter input[name='fushi']").val();
        if (containfilter >= 0 && han.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = false;
                for (var n = 0; n < han.length; n++) {
                    if (number.indexOf(han[n]) != -1) {
                        b = true;
                        break
                    }
                }
                if (containfilter == 0 && b) tmpNumArr.push(number);
                else if (containfilter == 1 && !b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("10|" + containfilter + "|" + han);

        }

        if (containfilter >= 0 && fushi.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                b = true;
                for (var n = 0; n < number.length; n++) {
                    if (number[n] != 'X' && fushi.indexOf(number[n]) == -1) {
                        b = false;
                        break
                    }
                }
                if (containfilter == 0 && b) tmpNumArr.push(number);
                else if (containfilter == 1 && !b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            inputCondition = true;
            kxlog.push("11|" + containfilter + "|" + fushi);

        }

        //重
        var chongname = ["two", "three", "four", "double"];
        var len = category < 4 ? category - 1 : category;
        var chongArr = [];
        for (var n = 0; n < len; n++) {
            var repeatwordsfilter = $("#kx_content  input[class='repeat-" + chongname[n] + "-words-filter']:checked").attr("repeatwordsfilter");
            if (repeatwordsfilter >= 0) {
                chongArr.push(n + ":" + repeatwordsfilter);
            }
        }
        if (chongArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;

                for (var n = 0; n < chongArr.length; n++) {
                    var chcondition = chongArr[n];

                    var index = parseInt(chcondition.split(":")[0]);
                    var qu = parseInt(chcondition.split(":")[1]);
                    var count = chong(number);

                    //双重
                    if (index == 0 && qu == 0 && count < 2) b = false;
                    if (index == 0 && qu == 1 && count >= 2) b = false;
                    if (index == 0 && qu >= 0 && !b) break;

                    //三重
                    if (category >= 3) {

                        if (index == 1 && qu == 0 && !(count >= 3 && count <= 4)) b = false;
                        if (index == 1 && qu == 1 && (count >= 3 && count <= 4)) b = false;
                        if (index == 1 && qu >= 0 && !b) break;

                    }

                    if (category == 4) {

                        //双双重
                        if (index == 3 && qu == 0 && !(count >= 4 && count <= 5)) b = false;
                        if (index == 3 && qu == 1 && (count >= 4 && count <= 5)) b = false;
                        if (index == 3 && qu >= 0 && !b) break;

                        //四重
                        if (index == 2 && qu == 0 && !(count == 4)) b = false;
                        if (index == 2 && qu == 1 && (count == 4)) b = false;
                        if (index == 2 && qu >= 0 && !b) break;
                    }
                }

                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("12|" + chongArr.join("|"));

        }

        //对数
        var logarithmnumberfilter = $("#kx_content input[class='logarithm-number-filter']:checked").attr("logarithmnumberfilter");
        var duishuiArr = [];
        for (var n = 1; n <= 3; n++) {
            var ds = $("#kx_content input[name='duishu" + n + "'] ").val();
            if (ds.length == 2 && (ds[0] - ds[1] == 5 || (ds[0] - ds[1] == -5))) {
                duishuiArr.push(ds);
            } else if (ds.length > 0) {
                gamedefault.G.myTips({ content: "请输入差值为5的数", obj: $("#kx_content input[name='duishu" + n + "'] "), myclick: true });
                return;
            }
        }
        if (logarithmnumberfilter >= 0 && duishuiArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                number = createNumberArr[i];
                b = false;
                for (var n = 0; n < duishuiArr.length; n++) {
                    if (number.indexOf(duishuiArr[n][0]) != -1 && number.indexOf(duishuiArr[n][1]) != -1) {
                        b = true;
                        break;
                    }
                }

                if (logarithmnumberfilter == 1) b = !b;

                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("13|" + logarithmnumberfilter + "|" + duishuiArr.join(":"));

        } else if (logarithmnumberfilter >= 0 && duishuiArr.length == 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                number = createNumberArr[i];
                number = number.replace(/X/g, '');
                b = false;
                for (var n = 0; n < number.length - 1; n++) {
                    for (var n2 = n + 1; n2 < number.length; n2++)
                        if (number[n] - number[n2] == 5 || number[n] - number[n2] == -5) {
                            b = true;
                            break;
                        }
                }


                if (logarithmnumberfilter == 1) b = !b;

                if (b) tmpNumArr.push(createNumberArr[i]);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("13|" + logarithmnumberfilter + "| ");

        }


        var brotherClass = ["two", "three", "four"];
        var brotherArr = [];
        for (var n = 0; n < category - 1; n++) {
            var brotherfilter = $("#kx_content input[class='" + brotherClass[n] + "-brother-filter']:checked").attr("brotherfilter");
            if (brotherfilter >= 0) {
                brotherArr.push(n + ":" + brotherfilter);
            }
        }
        if (brotherArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;

            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var k = 0; k < brotherArr.length; k++) {

                    var index = brotherArr[k].split(":")[0];
                    var qu = brotherArr[k].split(":")[1];

                    if (index == 0 && qu == 0 && brother(number) < 2) b = false;
                    if (index == 0 && qu == 1 && brother(number) >= 2) b = false;

                    if (index == 1 && qu == 0 && brother(number) < 3) b = false;
                    if (index == 1 && qu == 1 && brother(number) >= 3) b = false;

                    if (index == 2 && qu == 0 && brother(number) != 4) b = false;
                    if (index == 2 && qu == 1 && brother(number) == 4) b = false;

                    if (!b) break;
                }
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("14|" + brotherArr.join("|"));

        }

        var oddnumberfilter = $("#kx_content input[class='odd-number-filter']:checked").attr("oddnumberfilter");
        var evennumberfilter = $("#kx_content input[class='even-number-filter']:checked").attr("evennumberfilter");
        var oddnumberArr = [];
        var evennumberArr = [];

        var depos = 0;
        $("#kx_content input[class='odd-number-item']").each(function () {
            if ($(this).attr("checked")) oddnumberArr.push(depos);
            depos++;
        });

        if (oddnumberfilter >= 0 && oddnumberArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var n = 0; n < oddnumberArr.length; n++) {
                    if (number[oddnumberArr[n]] == "X" || parseInt(number[oddnumberArr[n]]) % 2 == 0) {
                        b = false;
                        break;
                    }
                }

                if (oddnumberfilter == 1) b = !b;
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("15|" + oddnumberfilter + "|" + oddnumberArr.join("|"));

        }

        depos = 0;
        $("#kx_content input[class='even-number-item']").each(function () {
            if ($(this).attr("checked")) evennumberArr.push(depos);
            depos++;
        });

        if (evennumberfilter >= 0 && evennumberArr.length > 0) {
            if (!inputCondition) createNumberArr = getNumbersByCategory(category, dw5zi);
            inputCondition = true;
            tmpNumArr = [];
            for (var i = 0; i < createNumberArr.length; i++) {
                var number = createNumberArr[i];
                var b = true;
                for (var n = 0; n < evennumberArr.length; n++) {
                    if (number[evennumberArr[n]] == "X" || parseInt(number[evennumberArr[n]]) % 2 != 0) {
                        b = false;
                        break;
                    }
                }

                if (evennumberfilter == 1) b = !b;
                if (b) tmpNumArr.push(number);
            }
            createNumberArr = tmpNumArr;
            kxlog.push("16|" + evennumberfilter + "|" + evennumberArr.join("|"));

        }

        if (!inputCondition) {
            gamedefault.G.alert({ content: "请选择或填写条件生成!", ok: function () { return true; } });
            return;
        }

        //kxnumbers
        if (createNumberArr.length == 0) {
            $("#kxnumbers").html("没有这样的号码");
        } else {
            createNumberArr = createNumberArr.sort();
            var row = parseInt(createNumberArr.length / 10);
            if (createNumberArr.length % 10 > 0) row += 1;
            var htmlData = [];
            htmlData.push("<table >");
            htmlData.push("<tbody >");


            for (var n = 0; n < row; n++) {
                htmlData.push("<tr>");
                for (var n2 = 0; n2 < 10; n2++) {
                    if (n * 10 + n2 < createNumberArr.length) {
                        var num = createNumberArr[n * 10 + n2];
                        htmlData.push("<td >" + (num[4] == 'X' ? num.substring(0, num.lastIndexOf('X')) : num) + "</td>");
                    } else {
                        htmlData.push("<td >--</td>");
                    }
                }
                htmlData.push("</tr>");
            }

            htmlData.push("</tbody>");
            htmlData.push("</table>");
            $("#kxnumbers").html(htmlData.join(""));
            $("#kxlog").html(category + "," + dw5zi + "," + kxlog.join(","));
            $("#zbishu").html(createNumberArr.length);
            if ($("#tool_ys_input").val().length > 0) {
                $("#zmoney").html(parseFloat($("#tool_ys_input").val()) * createNumberArr.length)
            } else {
                $("#zmoney").html("");
            }
        }
    });

}

function initkx(category, data) {
    kuaixian(category);


    var dataArr = data.split(",");
    if (category <= 3 && parseInt(dataArr[1]) == 1) {

        $("#kx_content input[name='dw5zi']").attr("checked", "checked");
    } else {
        $("#kx_content input[name='dw5zi']").attr("checked", false);

        $("#kx_content input[name='dw5zi'][data-index='" + dataArr[1] + "']").attr("checked", "checked");
    }

    for (var i = 2; i < dataArr.length; i++) {

        var str = dataArr[i];
        var strArr = str.split("|");
        //定位
        if (parseInt(strArr[0]) == 1) {
            if (parseInt(strArr[1]) == 1) {
                $("#kx_content tr.position-filter input[positiontype='0'][positionfilter='1']").attr("checked", "checked");
                $("#kx_content tr.position-filter input[positiontype='0'][positionfilter='0']").attr("checked", "");
            } else {
                $("#kx_content tr.position-filter input[positiontype='0'][positionfilter='0']").attr("checked", "checked");
                $("#kx_content tr.position-filter input[positiontype='0'][positionfilter='1']").attr("checked", "");
            }

            var posNumArr = strArr[2].split(":")
            $("#kx_content tr.fixed-input input[name='wan']").val(posNumArr[0]);
            $("#kx_content tr.fixed-input input[name='qian']").val(posNumArr[1]);
            $("#kx_content tr.fixed-input input[name='bai']").val(posNumArr[2]);
            $("#kx_content tr.fixed-input input[name='shi']").val(posNumArr[3]);
            $("#kx_content tr.fixed-input input[name='ge']").val(posNumArr[4]);

            $("#kx_content tr.fixed-input").attr("style", "");
            $("#kx_content tr.match-input").attr("style", "display: none");
            $("#kx_content tr.match-input input[type='text']").val('');


        }//配数
        else if (parseInt(strArr[0]) == 2) {
            $("#kx_content tr.position-filter input[positiontype='0']").attr("checked", false);

            if (parseInt(strArr[1]) == 1) {
                $("#kx_content tr.position-filter input[positiontype='1'][positionfilter='1']").attr("checked", "checked");
                $("#kx_content tr.position-filter input[positiontype='1'][positionfilter='0']").attr("checked", false);
            } else {
                $("#kx_content tr.position-filter input[positiontype='1'][positionfilter='0']").attr("checked", "checked");
                $("#kx_content tr.position-filter input[positiontype='1'][positionfilter='1']").attr("checked", false);
            }



            var peiNumArr = strArr[2].split(":");
            for (var n = 1; n <= category; n++) {
                $("#kx_content tr.match-input input[name='pei" + n + "']").val(peiNumArr[n - 1]);
            }

            $("#kx_content tr.fixed-input").attr("style", "display: none");
            $("#kx_content tr.match-input").attr("style", "");
            $("#kx_content tr.fixed-input input[type='text']").val('');

        }
        //全转
        else if (parseInt(strArr[0]) == 3) {
            $("#kx_content input[name='quanzhuan']").val(strArr[1]);
        }
        //上奖
        else if (parseInt(strArr[0]) == 4) {
            $("#kx_content input[name='shangjiang']").val(strArr[1]);
        }
        //值范围
        else if (parseInt(strArr[0]) == 5) {
            $("#kx_content td.zhi-filter-range input[name='zhifanwei1']").val(strArr[1].split("~")[0]);
            $("#kx_content td.zhi-filter-range input[name='zhifanwei2']").val(strArr[1].split("~")[1]);
        }
        //合分
        else if (parseInt(strArr[0]) == 6) {
            if (parseInt(strArr[1]) == 1) {
                $("#kx_content tr.hefen-filter input[hefentype='1']").attr("checked", "checked");
                $("#kx_content tr.hefen-filter input[hefentype='0']").attr("checked", false);
            } else {
                $("#kx_content tr.hefen-filter input[hefentype='1']").attr("checked", false);
                $("#kx_content tr.hefen-filter input[hefentype='0']").attr("checked", "checked");
            }

            var hefeninfo = strArr[2].split(";");
            var n = 0;
            $("#kx_content td.hefen-filter-item").each(function () {
                if (hefeninfo[n]) {
                    var posStr = hefeninfo[n].split("-")[0];
                    var pos = posStr.split(":");
                    $(this).find("input[type='text']").val(hefeninfo[n].split("-")[1]);

                    for (var n2 = 0; n2 < pos.length; n2++) {
                        $(this).find("input[type='checkbox']").eq(parseInt(pos[n2])).attr("checked", "checked");
                    }
                }

                n++;
            });
        }
        //不定位合分
        else if (parseInt(strArr[0]) == 7) {
            $("#kx_content td.budinghe-filter input[budinghetype='" + strArr[1] + "']").attr("checked", "checked");
            $("#kx_content td.budinghe-filter input[type='text']").val(strArr[2]);
        }
        //排除
        else if (parseInt(strArr[0]) == 8) {
            $("#kx_content input[name='paichu']").val(strArr[1]);
        }
        //乘号位置
        else if (parseInt(strArr[0]) == 9) {
            var chhaoArr = strArr[1].split(":");
            for (var n = 0; n < chhaoArr.length; n++) {
                $("#kx_content input.symbol-filter-item [name='" + chhaoArr[n] + "']").attr("checked", "checked");
            }
        }
        //含数复数
        else if (parseInt(strArr[0]) == 10) {
            $("#kx_content td.contain-filter input[containfilter='" + strArr[1] + "']").attr("checked", "checked");
            $("#kx_content td.contain-filter input[name='han']").val(strArr[2]);
        }
        else if (parseInt(strArr[0]) == 11) {
            $("#kx_content td.contain-filter input[containfilter='" + strArr[1] + "']").attr("checked", "checked");
            $("#kx_content td.contain-filter input[name='fushi']").val(strArr[2]);
        }
        //重
        else if (parseInt(strArr[0]) == 12) {
            var chongname = ["two", "three", "four", "double"];
            for (var n = 1; n < strArr.length; n++) {
                console.log(strArr[n]);
                $("#kx_content input[class='repeat-" + chongname[parseInt(strArr[n].split(":")[0])] + "-words-filter'][repeatwordsfilter='" + strArr[n].split(":")[1] + "']").attr("checked", "checked");

            }
        }
        //对数
        else if (parseInt(strArr[0]) == 13) {
            $("#kx_content input[class='logarithm-number-filter'][logarithmnumberfilter='" + strArr[1] + "']").attr("checked", "checked");

            var duishuiArr = strArr[2].split(":");
            for (var n = 1; n <= duishuiArr.length; n++) {
                $("#kx_content input[name='duishu" + n + "'] ").val(duishuiArr[n - 1]);
            }
        }
        //兄弟
        else if (parseInt(strArr[0]) == 14) {
            var brotherClass = ["two", "three", "four"];
            for (var n = 1; n < strArr.length; n++) {
                $("#kx_content input[class='" + brotherClass[parseInt(strArr[n].split(":")[0])] + "-brother-filter'][brotherfilter='" + strArr[n].split(":")[1] + "']").attr("checked", "checked");
            }
        }
        //单双
        else if (parseInt(strArr[0]) == 15) {
            $("#kx_content input[class='odd-number-filter'][oddnumberfilter='" + strArr[1] + "']").attr("checked", "checked");

            for (var n = 2; n < strArr.length; n++) {
                $("#kx_content").find("input[class='odd-number-item']").eq(parseInt(strArr[n])).attr("checked", "checked");
            }
        }
        else if (parseInt(strArr[0]) == 16) {
            $("#kx_content input[class='even-number-filter'][evennumberfilter='" + strArr[1] + "']").attr("checked", "checked");

            for (var n = 2; n < strArr.length; n++) {
                $("#kx_content").find("input[class='even-number-item']").eq(parseInt(strArr[n])).attr("checked", "checked");
            }
        }

    }

    $("#kx_content input[name='create-number']").click();
}

//快译
function kuaiyi(numStr, vue) {
    $("#kySubmit").unbind("click").click(function () {
        var money = $("#tool_ys_input").val();
        if (money.length == 0 && parseFloat(money) <= 0) {
            return;
        }

        if (numStr.length == 0) {
            return;
        }
        if (numStr.split(" ").length > 10000) {
            gamedefault.G.alert({ content: "单笔最大只能下注10000注", ok: function () { return true; } });
            return;
        }
        let str = numStr.split(' ');
        let newArr = []
        if (str[0].split("=")[1]) {
            str.forEach(item => {
                item = item.replace('=', ':')
                if(item.split(":")[0].substr(item.split(":")[0].length-1, 1) == 'X' && item.split(":")[0].replace(/\D/g, '').length >= 2){
                    item = `${item.split(":")[0].substr(0, 4)}:${item.split(":")[1]}`
                }
                if(item != ""){
                    let flag = false
                    newArr.forEach((newItem,index) => {
                        if(newItem.split(':')[0] == item.split(':')[0]){
                            flag = true
                            newArr[index] = `${newItem.split(':')[0]}:${(newItem.split(':')[1] *1) + (item.split(':')[1] * 1)}`
                        }
                    })
                    if(!flag){
                        newArr.push(item)
                    }

                }
            })
        }else{
            str.forEach(item => {
                console.log(item)
                if(item.substr(item.length-1, 1) == 'X' && item.replace(/\D/g, '').length >= 2){
                    item = item.substr(0, 4)
                }
                if(item != ''){
                    newArr.push(`${item}:${money}`)
                }
            })
        }
        $("#tool_ys_input").val("");
        let data = {};

        data.access_token = window.sessionStorage.getItem("login").split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.game_code = window.sessionStorage.getItem("code");
        // data.play_code = 'daoru';
        data.key = +new Date();
        data.play_type = "daoru";
        // data.bet_money = money;
        data.total_money = $("#zmoney").html();
        data.bet_num = newArr.length;
        data.bet_str = newArr.join(',');
        data.bet_log = "游戏日志";
        data.bet_qihao = window.sessionStorage.getItem("qiNum");

        $("#mymask").remove();
        $("#myLayerImg").remove();
        $("body").append("<div class='myLayerLoading' id='mymask'></div>");
        $("body").append("<div class='myLayerImg' id='myLayerImg'></div>");
        $("#mymask").show();
        $("#myLayerImg").show();
        getData.default.postAxiosMethod('bet2', data, res => {
            $("#myLayerImg").remove();
            $("#mymask").remove();
            $('.kxhotbtn').removeClass('kxhotbtn').addClass('kxbtn')
            gamedefault.container()
            txtdaoru()
            vue.$BGM()
            setTimeout(() => {
                vue.$event.$emit('yzdData', 4)
            }, 1000);
        });
        $("#tool_ys_input").val("");

    });
}

function kycontent() {

    var rightBox =
        "<div  class=' t_1' style='width: 600px;background: white'>" +

        "<div class='history_wrap'>" +
        "<div style='border:1px #ccc solid;padding:5px;margin: 5px'> " +
        "<textarea rows='12' style='box-sizing: border-box;text-align:left;resize:none;width:100%;border:none;' maxlength='2000' name='kuaiyi' id='textarea'></textarea> " +
        "</div>" +
        "<div style='margin: 5px'>" +
        "<div>重要提示:</div>" +
        "<ol > " +
        "<li>1、本公司推出“快译”是为了方便客户进行投注，为了避免给自己带来不必要的损失，敬请各位客户务必检仔细查确认后再下注！<font color=\"Red\">公司一切以下注明细为准</font>，如有不便，希望各位会员谅解！</li> " +
        "<li>2、<a target=\"_blank\" href=\"http://k1.cq718718.xyz/Htmls/kyguize.html\" style=\"text-decoration:underline;\"><font color=\"Red\">快译规则说明</font></a></li> " +
        "<li>3、每条规则中会去掉重复的号码</li> " +
        "</ol>" +
        "</div>" +
        "</div>" +
        "</div>";
    $("#rightBox").html(rightBox);

}

//txt导入
function txtdaoru() {
    $("#mainIframe").find("div[class='gameLeft']").attr("style", "width: 900px");
    $("#mainIframe").find("div[class='game_wrap']").attr("style", "width: 900px");
    $("#mainIframe").find("div[class='game_item_warp']").attr("style", "width: 900px");
    $("#gameBoxTool").attr("style", "width: 878px;min-width: 878px");
    $("#rightBox").html("");
    game_loading_wrap(false);
    var htmlData = ["<div  class='t_1' style='max-height: 500px;min-height: 370px'> <div id='txtnumbers' class='history_wrap' style='max-height: 500px;min-height: 370px'>"];
    htmlData.push("<div> <strong>&nbsp;&nbsp;格式A：</strong>号码，号码，号码&nbsp;&nbsp;&nbsp;&nbsp;<strong>格式B：</strong>号码=金额，号码=金额，号码=金额 <span class=\"red\">(逗号也可以用空格代表)</span>&nbsp;&nbsp;&nbsp;&nbsp;</div><br>");
    htmlData.push("<div>&nbsp;&nbsp;说明：由于各会员使用的（txt文件）的格式不一样，如果不符合网站上要求的格式，有可能导入到网站（没有下注之前）的号码内容和自己（txt文件）里号码内容不一致，操作时请认真检查，如果出现内容不一致，请不要下注。 </div>");
    htmlData.push("</div></div>");
    $("#gameBox").html(htmlData.join(""));

    var gameBoxTool = "<div class='tool_left'>" +
        "<div id='tool_ys_wrap' class='t_left'>" +
        "<label for='tool_ys_input'>下注金额：</label><input id='tool_ys_input' class='input onlyNum' maxlength='5' type='text'>" +
        "&nbsp;&nbsp;<input id='text'  type='file'>" +
        "&nbsp;&nbsp;<input id='kySubmit'  class='btn hotBtn disSubmit' type='button' value='提交'>" +
        " &nbsp;&nbsp;笔数：<span id='zbishu' style='color: #ff0000'></span>" +
        " &nbsp;&nbsp;金额：<span id='zmoney' style='color: #ff0000'></span>" +
        "</div></div>";
    $("#gameBoxTool").html(gameBoxTool);

    $("#tool_ys_input").keyup(function () {
        //$(this).val($(this).val().replace(/[^0-9]/g, ''));
        gamedefault.G.clearNoNum($(this));
        var bishu = $("#zbishu").html();
        if (bishu.length > 0 && $(this).val().length > 0) {
            $("#zmoney").html(parseInt(bishu) * parseFloat($(this).val()));
        } else {
            $("#zmoney").html("");
        }

    });
    var numberArr = [];
    $("#text").change(function () {
        numberArr = uploadfile()
    });

    $("#kySubmit").unbind("click").click(function () {
        //var numberArr = uploadNumArr;

        if (numberArr.length == 0 || $("#txtnumbers").html() == "") {
            return;
        }

        if ($("#tool_ys_input").attr("disabled") == undefined) {
            var money = $("#tool_ys_input").val();
            if (money.length == 0 && parseFloat(money) < 0.1) {
                return;
            }

            var temp = [];
            for (var n = 0; n < numberArr.length; n++) {
                temp.push(numberArr[n].split(":")[0] + ":" + money)
            }
            numberArr = temp;
        }

        if (numberArr.length > 10000) {
            gamedefault.G.alert({ content: "单笔最大只能下注10000注", ok: function () { return true; } });
            return;
        }

        var gameIndex = $("#menuText").attr("data-index");
        var opNum = $("#NowJq").html();
        numberArr.sort(function (a, b) {
            var _a = a.split(":")[0], _b = b.split(":")[0];
            return parseInt(_b) - parseInt(_a);
        });
        var printAry = [];

        $("#tool_ys_input").val("");

        dataSubmit({ gameIndex: gameIndex, betType: 5, number: opNum, sortAry: numberArr.join(",") }, false, null, printAry);


    });
}
function uploadfile(vue) {

    var numberList = [];
    var typeList = [];

    var file = $("#text")[0].files[0];
    //       指定上传文件为txt格式
    if (file.name.split(".")[file.name.split(".").length - 1] != "txt") {
        alert("请上传格式为TXT的文件。")
    } else {


        var reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = function (evt) {
            var data = evt.target.result;
            data = data.replace(/\n/g, ' ');
            data = data.replace(/\r\n/g, ' ');
            data = data.replace(/,/g, ' ');
            data = data.replace(/，/g, ' ');
            data = data.replace(/\s+/g, ' ');
            var dataAry = data.split(' ');
            kuaiyi(data, vue);
            var htmldata = [];
            var hasMoney = false;
            htmldata.push("<table><thead>");
            if (data.indexOf("=") != -1) {
                for (var i = 0; i < 12; i++) {
                    if (i % 2 == 0) htmldata.push("<td>号码</td>");
                    else htmldata.push("<td>金额</td>");
                }
                hasMoney = true;
            } else {
                for (var i = 0; i < 12; i++) {
                    htmldata.push("<td>号码</td>");
                }
            }

            htmldata.push("</thead><tbody>");
            var i = 0, totalmoney = 0;
            for (var n = 0; n < dataAry.length; n++) {
                var number = dataAry[n].split("=")[0];
                var money = 0;
                if (dataAry[n].split("=").length >= 2) {
                    money = dataAry[n].split("=")[1];
                }
                var type = getDWTypeByName(number);
                // console.log(number, "--" ,type)
                if (type == 0) continue;
                // if (type == 0 || typeList.indexOf(type) != -1) continue;

                if (i == 0) {
                    htmldata.push("<tr>");
                } else if (hasMoney) {
                    if (i % 6 == 0) {
                        htmldata.push("</tr><tr>");
                    }
                } else {
                    if (i % 12 == 0) {
                        htmldata.push("</tr><tr>");
                    }
                }
                htmldata.push("<td>" + number + "</td>");
                if (hasMoney) money = money == 0 ? 1 : money;
                if (hasMoney) htmldata.push("<td>" + (money == 0 ? "--" : money) + "</td>");
                i++;
                numberList.push(type + ":" + money);
                typeList.push(type);
                totalmoney = floatAdd(totalmoney, parseFloat(money));
            }
            htmldata.push("</tr></tbody></table>");
            $("#txtnumbers").html(htmldata.join(""));
            $("#zbishu").html(i);
            $("#zmoney").html(totalmoney);
            if (totalmoney > 0) $("#tool_ys_input").attr('disabled', true);
            else $("#tool_ys_input").attr('disabled', false);
        }
    }

    return numberList;
}


module.exports = {
    txtdaoru,
    uploadfile
}
